import { exportApis } from '@/scripts/utils/devUtils';
import { chatApis as chatApis_ } from './chats';
import { commonApis } from './common';
import { messageApis } from './messages';
import { mediaApis } from './media';

export const chatApis = {
  ...commonApis,
  ...chatApis_,
  ...messageApis,
  ...mediaApis,
};

exportApis({ chatApis });
